<template>
  <div id="introduce-guideline">
    <section ref="TổngQuanMànHìnhAddTask" id="TổngQuanMànHìnhAddTask">
      <h3>Tổng Quan Màn Hình Add Task</h3>
      <div>
        <p>
          Màn hình chính để tìm kiếm các content đang có trên VieON và tiến hành
          tạo các <b> AI task</b> cho các content đó
        </p>
        <ul>
          <li>
            <b>Celeb</b> : nhận diện nghệ sĩ, hành động của nghệ sĩ, cảm xúc
            nghệ sĩ
          </li>
          <li><b>Scene</b> : Nhận diện ngữ cảnh</li>
          <li><b>Common object</b>: Nhận diện các đối tượng phổ biến</li>
          <li>
            <b>Branding</b>: Nhận diện các thương hiệu cụ thể qua hình ảnh
          </li>
          <li><b>Gender</b> : Nhận diện giới tính</li>
          <li><b>Age</b> : Nhận diện độ tuổi</li>
          <li><b>Food</b> : Nhận diện món ăn (Đang được update)</li>
          <li><b>Color</b> : Phân tích màu sắc chủ đạo trong video</li>
          <li>
            <b>DeepFashion</b>: Nhận diện các mẫu áo quần phổ biến của nhân vật
          </li>
          <li><b>Keyword</b> : Rút trích các từ khóa trong file kịch bản.</li>
          <li>
            <b>Poster-candidate</b>: trích xuất thumbnail từ vod, hỗ trợ cắt
            trailer, trích xuất thumbnail từ trailer.
          </li>
        </ul>
      </div>
    </section>
    <v-divider></v-divider>
    <section ref="HướngDẫnCáchAddTask" id="HướngDẫnCáchAddTask">
      <h3>Hướng dẫn cách add task</h3>

      <img src="../../assets/tutorial/screen-addtask.png" />
      <div>
        <p>
          <b>Khu Vực Số 1 :</b>
          Search các content đang có trên VieON theo 3 type: tất cả content,
          theo phim bộ, theo phim tập
        </p>
        <p>
          <b>Khu Vực Số 2 :</b>
          Danh sách kết quả search
        </p>
        <p>
          Đối với các content là
          <b> phim nhiều tập</b> phải click và content và lựa chọn danh sách các
          tập cần chạy task, sau đó nhấn button add task
        </p>
        <p>
          Đối với các content là <b>phim lẻ</b> , người dung có thể lựa chọn một
          hoặc nhiều phim cùng một lúc để thực hiện add task
        </p>
      </div>
      <div>
        <h5>
          Sau khi nhấn
          <v-btn
            ><v-icon>{{ mdiRobot }}</v-icon> Add Task</v-btn
          >
          sẽ hiện ra màn hình như bên dưới:
        </h5>
        <img src="../../assets/tutorial/add-task-action.png" alt="" />
        <ul>
          <li>
            <p>
              <b>(1)</b> Trạng thái của các task AI đã được chạy trên content
            </p>
            <p>
              <b>(2)</b> Nhấn <b>on</b> để chạy lại và ghi đè lên các kết quả
              của các task đã chạy trước đây,<b>off</b> sẽ không chạy lại các
              content đã được chạy thành công trước đây
            </p>
            <p><b>(3)</b> Thêm <b>priority</b> cho từng content</p>
            <p>
              <b>(4)</b> Lựa chọn các đoạn thời gian cần chạy thay vì chạy toàn
              bộ content (hiện tại chỉ đang áp dụng cho task Poster candidate)
            </p>
            <p>
              <b>(5)</b> <b>Thêm/Xóa </b> các phân đoạn thời gian cho toàn bộ
              các content đang có trên màn hình
            </p>
            <p><b>(6)</b> Thêm <b>priority</b> cho toàn bộ content</p>
            <p>
              <b>(7)(8)</b> Các option bổ sung của các task :
              <v-img
                src="../../assets/tutorial/add-task-celeb-dialog.png"
              ></v-img>
              <span
                >Đối với task Celeb sẽ có “full option” : model sẽ nhận diện
                hình ảnh kèm cảm xúc và hành động của nghệ sĩ đó. Mặc định chỉ
                nhận diện hình ảnh và cảm xúc. Nếu chọn full option thì task
                nhận diện sẽ thực hiện với thời gian lâu hơn</span
              >
              <span
                >Đối với task poster : “Get thumbs” : Xuất hình ảnh, “Get
                trailer” : Xuất clips (nếu user có chọn các segment cho
                content)</span
              >
            </p>
          </li>
        </ul>
        <h5>Sau khi Add task sẽ có các trạng thái xảy ra :</h5>
        <ul>
          <li>
            <p>
              - Task đã chạy thành công và không được chạy lại (trường hợp không
              lựa chọn option retry)
            </p>
          </li>
          <li>
            <p>
              - Task chạy thất bại ( sẽ có thông tin lỗi được show lên ở từng
              task)
            </p>
          </li>
          <li>
            <p>- Task đang xử lý ( gửi task thành công và đang chạy)</p>
          </li>
        </ul>
        <p>
          Lưu ý : Đối với task Branding bắt buộc phải chọn folder hình ảnh đầu
          vào,<b class="text-danger">
            các content muốn chạy được task này bắt buộc phải chạy thành công
            task common object trước</b
          >
        </p>
      </div>
    </section>
    <v-divider></v-divider>
    <section ref="HướngDẫnXemListTask" id="HướngDẫnXemListTask">
      <h3>Hướng dẫn xem list task đã add</h3>
      <div>
        <p>
          Sau Khi <b>Add Task</b> ,Ở bên phải sát cạnh màn hình có button
          <img
            width="40"
            height="40"
            src="../../assets/tutorial/button-add-task.png"
          />
        </p>
        <p>Click vào button này,sẽ hiển thị màn hình giống bên dưới :</p>
        <v-img src="../../assets/tutorial/add-task.png"></v-img>
        <p>
          Danh sách <b>trạng thái </b> các <b>task AI </b> đang được chạy bởi
          user đang login
        </p>
        <p>
          Với tab danh sách các task AI đang chạy, có thể click vào title hoặc
          chi tiết từng label task để dẫn đến trang hiển thị kết quả tương ứng
          của từng task sau khi chạy
        </p>
        <p>
          Ở đây sẽ có 3 trang thái,<b>success,</b>
          <b>pending,</b>
          <b>error</b>
        </p>
        <p>Người dùng <b>hover</b> vào task đó để xem chi tiết</p>
        <p>
          Người dùng <b>click</b> vào task đó để đến thẳng video của task này
          (Là màn hình Details Content)
        </p>
      </div>
    </section>
    <v-divider></v-divider>
    <section
      ref="HướngDẫnCáchAddTaskBằngVideo"
      id="HướngDẫnCáchAddTaskBằngVideo"
    >
      <h4>Hướng dẫn cách add task bằng Video</h4>
      <div>
        <video width="400" controls>
          <source
            src="../../assets/tutorial/huong-dan-add-task.mp4"
            type="video/mp4"
          />
        </video>
      </div>
    </section>
  </div>
</template>

<script>
import { call, sync } from "vuex-pathify";
import { mdiChatAlert, mdiRobotOutline } from "@mdi/js";

export default {
  data() {
    return {
      mdiChatAlert: mdiChatAlert,
      mdiRobot: mdiRobotOutline,
      currentSectionId: "",
    };
  },

  mounted() {
    window.addEventListener("scroll", this.handleScroll);

    let items = document.getElementById("introduce-guideline")?.childNodes;
    if (items) {
      let ids = Array.prototype.reduce.call(
        items,
        function (arr, elem) {
          arr.push(elem.id);
          return arr;
        },
        []
      );
      this.setListTitle([...ids]);
    }
  },
  beforeDestroy() {
    localStorage.removeItem("myAnchorTilte");
    this.setListTitle([]);
  },
  computed: {
    myAnchorTilte: sync("showcase/myAnchorTilte"),
  },
  methods: {
    setListTitle: call("showcase/setListTitle"),
    handleScroll() {
      const scrollTop =
        window.pageYOffset || document.documentElement.scrollTop;
      const sections = document.getElementById(
        "introduce-guideline"
      ).childNodes;
      let currentSectionIndex = 0;
      for (let i = 0; i < sections.length; i++) {
        const sectionTop = sections[i].offsetTop - 125;
        const sectionBottom = sectionTop + sections[i].offsetHeight;
        if (scrollTop >= sectionTop && scrollTop < sectionBottom) {
          currentSectionIndex = i;
          break;
        }
      }
      const currentSectionId = sections[currentSectionIndex].getAttribute("id");

      if (this.myAnchorTilte !== currentSectionId) {
        this.myAnchorTilte = currentSectionId;
        localStorage.setItem("myAnchorTilte", currentSectionId);
      }
    },
  },
};
</script>

<style lang="scss">
.video-player-custom-controls {
  width: 100%;
  aspect-ratio: 16/9;
  position: relative;
  video {
    position: absolute;
    top: 0;
    left: 0;
  }
  .custom-controls {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    opacity: 0;
    transition: 0.5s all;

    &:hover {
      opacity: 1;
    }
    .title {
      color: white;
      padding: 2%;
      box-shadow: rgba(0, 0, 0, 0.3) 15px 15px 15px 5px inset;
    }
    .control-bottom {
    }
  }
}
</style>
